import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import initializeSDKs from './authentication/sdkInitialization';
import LogRocket from 'logrocket';
import config from './config';

// Root Component
import App from './App.js';

// import i18n translation
import './i18n';

// initialize required SDKs
initializeSDKs();

LogRocket.init(config?.logRocket);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
